import { render, staticRenderFns } from "./BillingMethodAndRefundPolicy.vue?vue&type=template&id=e8b329ba&scoped=true&"
import script from "./BillingMethodAndRefundPolicy.vue?vue&type=script&lang=js&"
export * from "./BillingMethodAndRefundPolicy.vue?vue&type=script&lang=js&"
import style0 from "./BillingMethodAndRefundPolicy.vue?vue&type=style&index=0&id=e8b329ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b329ba",
  null
  
)

export default component.exports